"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function AnteBase(config, factory) {
    this.contractInstances = {};
    this.config = config;
    this.contractsFactory = factory;
}
AnteBase.prototype.getContractInstance = function (address) {
    if (!this.contractInstances[address]) {
        this.contractInstances[address] = this.contractsFactory.connect(address, this.config.provider);
    }
    return this.contractInstances[address];
};
AnteBase.prototype.getProvider = function () {
    return this.config.provider;
};
exports.default = AnteBase;
